import React, { forwardRef, MutableRefObject } from 'react';
import { WithTranslationsProps } from 'react-utilities';
import { TGameData } from '../types/bedev1Types';
import { SponsoredGameTile } from './SponsoredGameTile';
import { GameTile } from './GameTile';
import { TSharedGameTileProps, TOnTileClick } from './GameTileUtils';
import '../../../../css/common/_gameGrid.scss';

export type TIEGameGridProps = {
  gameData: TGameData[];
  emphasis?: boolean;
  translate: WithTranslationsProps['translate'];
  onTileClick: TOnTileClick;
  tileRef?: MutableRefObject<HTMLDivElement | null>;
};

export const IEGameGridTile = forwardRef<
  HTMLDivElement,
  {
    emphasis: boolean;
  } & TSharedGameTileProps
>(
  (
    props: {
      emphasis: boolean;
    } & TSharedGameTileProps,
    ref
  ) => {
    if (props.gameData.isSponsored) {
      return <SponsoredGameTile ref={ref} {...props} />;
    }

    return <GameTile ref={ref} {...props} />;
  }
);

export const IEGameGrid = forwardRef<HTMLDivElement, TIEGameGridProps>(
  ({ gameData, translate, emphasis, onTileClick, tileRef }: TIEGameGridProps, forwardedRef) => {
    return (
      <div ref={forwardedRef} className='ie-game-grid'>
        {gameData.map((data, positionId) => (
          <IEGameGridTile
            ref={ref => {
              if (
                ((emphasis === true && positionId === 1) ||
                  (emphasis === false && positionId === 0)) &&
                tileRef
              ) {
                // eslint-disable-next-line no-param-reassign
                tileRef.current = ref;
              }
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={positionId}
            id={positionId}
            gameData={data}
            translate={translate}
            onTileClick={onTileClick}
            emphasis={emphasis === true && positionId === 0}
          />
        ))}
      </div>
    );
  }
);

export default IEGameGrid;
